module.exports = __webpack_public_path__ + "722acce5c768de0b37e9ecb2ad4b8fa8.svg";